export const APIURL = process.env.REACT_APP_API_HOSTNAME
export const IS_EMBEDDED = process.env.REACT_APP_IS_EMBEDDED
